export function uniqueId() {
  return (new Date().valueOf() + Math.random()).toString();
}
export const globalUniqueId = uniqueId();
